import { render, staticRenderFns } from "./MethodsComparisonTable.vue?vue&type=template&id=65c553a1&scoped=true&"
import script from "./MethodsComparisonTable.vue?vue&type=script&lang=js&"
export * from "./MethodsComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./MethodsComparisonTable.vue?vue&type=style&index=0&id=65c553a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c553a1",
  null
  
)

export default component.exports